import styled from 'styled-components';

const HomePageWrapper = styled.div`
    background-color: #e8e3eb;
    padding-bottom: 50px;
    margin-bottom: -50px;
`;

export default HomePageWrapper;
